import React, { useState } from 'react';
import './SupplierOrderNotes.css';

// Firmaya WhatsApp ile geçilen siparişin hangi parçası için gönderildiği
export const SUPPLIER_PART_LABELS = {
  urun: '',
  kumas: 'Kumaş',
  mekanizma: 'Mekanizma',
  motor: 'Motor',
  aksesuar: 'Aksesuar',
  ozelTasarim: 'Özel Tasarım',
  astar: 'Astar',
};

const formatSentAt = (value) => {
  const date = value?.toDate ? value.toDate() : new Date(value);
  if (isNaN(date.getTime())) return '';
  return date.toLocaleString('tr-TR', { day: '2-digit', month: '2-digit', year: 'numeric', hour: '2-digit', minute: '2-digit' });
};

/**
 * Siparişe düşülen "firmaya sipariş geçildi" notları.
 * entries: [{ id, part, firmaName, sentAt, sentBy }]  ·  onCancel(id): notu iptal et (iki adımlı onay)
 */
const SupplierOrderNotes = ({ entries, onCancel, canCancel = true, compact = false, busyId = null }) => {
  const [confirmId, setConfirmId] = useState(null);
  if (!Array.isArray(entries) || entries.length === 0) return null;

  return (
    <ul className={`sop${compact ? ' sop-compact' : ''}`} aria-label="Firmaya geçilen siparişler">
      {entries.map((entry) => {
        const partLabel = SUPPLIER_PART_LABELS[entry.part] || '';
        const confirming = confirmId === entry.id;
        const busy = busyId === entry.id;
        return (
          <li key={entry.id} className={`sop-item${confirming ? ' is-confirming' : ''}`}>
            <span className="sop-icon" aria-hidden="true">
              <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round">
                <path d="M20 6 9 17l-5-5" />
              </svg>
            </span>
            <span className="sop-text">
              <span className="sop-label">Sipariş geçildi</span>
              {entry.firmaName && <strong className="sop-firma">{entry.firmaName}</strong>}
              {partLabel && <span className="sop-part">{partLabel}</span>}
              {entry.sentAt && <time className="sop-time">{formatSentAt(entry.sentAt)}</time>}
            </span>
            {canCancel && onCancel && (
              confirming ? (
                <span className="sop-confirm">
                  <span className="sop-confirm-text">İptal edilsin mi?</span>
                  <button
                    type="button"
                    className="sop-btn sop-btn-danger"
                    disabled={busy}
                    onClick={async () => { await onCancel(entry.id); setConfirmId(null); }}
                  >
                    {busy ? '…' : 'Evet'}
                  </button>
                  <button type="button" className="sop-btn" disabled={busy} onClick={() => setConfirmId(null)}>
                    Vazgeç
                  </button>
                </span>
              ) : (
                <button
                  type="button"
                  className="sop-cancel"
                  onClick={() => setConfirmId(entry.id)}
                  aria-label={`${entry.firmaName || 'Firma'} sipariş notunu iptal et`}
                  title="Sipariş notunu iptal et"
                >
                  <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
                    <path d="M18 6 6 18M6 6l12 12" />
                  </svg>
                </button>
              )
            )}
          </li>
        );
      })}
    </ul>
  );
};

/**
 * "Firmaya geçildi" onay kutusu (sipariş listesi).
 * İşaretlenince onCheck() ile not eklenir; işaret kaldırılırken onay sorulur ve onUncheck() tüm notları siler.
 */
export const SupplierCheck = ({ checked, checkedLabel = 'Firmaya geçildi', onCheck, onUncheck, canEdit = true, busy = false }) => {
  const [confirming, setConfirming] = useState(false);

  if (confirming) {
    return (
      <span className="sop-check-confirm">
        <span className="sop-confirm-text">İşaret kaldırılsın mı?</span>
        <span className="sop-confirm">
          <button
            type="button"
            className="sop-btn sop-btn-danger"
            disabled={busy}
            onClick={async () => { await onUncheck(); setConfirming(false); }}
          >
            {busy ? '…' : 'Evet'}
          </button>
          <button type="button" className="sop-btn" disabled={busy} onClick={() => setConfirming(false)}>
            Vazgeç
          </button>
        </span>
      </span>
    );
  }

  return (
    <button
      type="button"
      role="checkbox"
      aria-checked={checked}
      className={`sop-check${checked ? ' is-checked' : ''}`}
      disabled={!canEdit || busy}
      onClick={() => (checked ? setConfirming(true) : onCheck())}
      title={checked ? `Firmaya sipariş geçildi: ${checkedLabel}` : 'Firmaya sipariş geçildi olarak işaretle'}
    >
      <span className="sop-check-box" aria-hidden="true">
        {checked && (
          <svg width="12" height="12" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="3.2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M20 6 9 17l-5-5" />
          </svg>
        )}
      </span>
      <span className="sop-check-label">{busy ? 'Kaydediliyor…' : checked ? checkedLabel : 'Firmaya geçilmedi'}</span>
    </button>
  );
};

export default SupplierOrderNotes;
